/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Subscriptions_HubInputs */

const en_why_listening_subscriptions_hub = /** @type {(inputs: Why_Listening_Subscriptions_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`apps, 3 subscriptions`)
};

const es_why_listening_subscriptions_hub = /** @type {(inputs: Why_Listening_Subscriptions_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`apps, 3 suscripciones`)
};

/**
* | output |
* | --- |
* | "apps, 3 subscriptions" |
*
* @param {Why_Listening_Subscriptions_HubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_subscriptions_hub = /** @type {((inputs?: Why_Listening_Subscriptions_HubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Subscriptions_HubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_subscriptions_hub(inputs)
	return en_why_listening_subscriptions_hub(inputs)
});